import { render, staticRenderFns } from "./27.vue?vue&type=template&id=32e0e1ac&scoped=true&"
var script = {}
import style0 from "./27.vue?vue&type=style&index=0&id=32e0e1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e0e1ac",
  null
  
)

export default component.exports